import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, setUserId, removeUserId, setUserName, getUserName, setOrganization, getLogo } from '@/utils/auth'
import router, { resetRouter } from '@/router'
// import { asyncRoutes } from '@/router/routeMap.js'
import { setRemoteControl } from "@/plugins/public.js";
const logoImg = require("@/assets/img/logo.png")

export function generatePermissions(routes) {
    let res = []
    routes.forEach(route => {
        const tmp = { ...route }
        if (tmp.menuType === 'B' && tmp.permission) {
            res.push(tmp.permission)
        }
        if (tmp.children) {
            res = res.concat(generatePermissions(tmp.children))
        }
    })
    return res
}

const state = {
    token: getToken(),
    name: '', // 用户名
    account: getUserName(), // 账号
    department: '', // 部门
    mobile: '', // 手机号
    avatar: '', // 头像
    logo: getLogo(), // 企业logo
    isChangPassword: false, // 当前账号是否允许修改密码
    introduction: 'I am a super administrator',
    enterpriseName: '云控系统',// 企业名称
    roles: [],
    permissions: []
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_ACCOUNT: (state, account) => {
        state.account = account
    },
    SET_DEPARTMENT: (state, department) => {
        state.department = department
    },
    SET_MOBILE: (state, mobile) => {
        state.mobile = mobile
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_LOGO: (state, logo) => {
        state.logo = logo
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    },
    SET_isChangPassword: (state, isChangPassword) => {
        state.isChangPassword = isChangPassword
    },
    set_enterpriseName: (state, name) => {
        state.enterpriseName = name
    }
}

const actions = {
    // user login
    login({ commit }, userInfo) {
        const { username, password } = userInfo
        return new Promise((resolve, reject) => {
            login({ username: username.trim(), password: password }).then(response => {
                const { data } = response
                commit('SET_TOKEN', data.token)
                setToken(data.token)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getInfo({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            getInfo(state.token).then(response => {
                const { state, data } = response.data
                if (state === 1) {
                    const { name, userName, deptName, mobile, imagePath, roles, permissions, enterpriseInfo = {}, changePassword, id } = data
                    commit('SET_NAME', name)
                    commit('SET_DEPARTMENT', deptName)
                    commit('SET_MOBILE', mobile)
                    setUserId(id)
                    setUserName(userName)
                    setOrganization(enterpriseInfo)
                    if (enterpriseInfo) {
                        commit('SET_LOGO', enterpriseInfo.imagePath || '')
                        commit('set_enterpriseName', enterpriseInfo.name || '云控系统企业版')
                    }
                    commit('SET_AVATAR', imagePath)
                    commit('SET_PERMISSIONS', permissions)
                    commit('SET_ROLES', roles)
                    commit('SET_isChangPassword', changePassword)
                    resolve(data)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 设置浏览器标签页图标
    setIcon({ commit, state }) {
        const href = state.logo || logoImg
        const link = document.getElementsByTagName('head')[0].querySelector('#ttaIcon')
        if (link) {
            link.setAttribute('href', href)
        } else {
            const link = document.createElement('link')
            link.setAttribute('rel', 'icon')
            link.setAttribute('id', 'ttaIcon')
            link.setAttribute('href', href)
            document.getElementsByTagName('head')[0].appendChild(link)
        }
    },

    // user logout
    async logout({ state, dispatch }) {
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                dispatch('resetAll')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // reset all
    resetAll({ dispatch }) {
        setRemoteControl(0);
        return new Promise(resolve => {
            dispatch('resetToken')
            dispatch('permission/resetRoutes', null, { root: true })
            resetRouter()
            dispatch('tagsView/delAllViews', null, { root: true })
            resolve()
        })
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeUserId()
            resolve()
        })
    },

    // dynamically modify permissions
    async changeRoles({ commit, dispatch }, role) {
        const token = role + '-token'

        commit('SET_TOKEN', token)
        setToken(token)

        const { roles } = await dispatch('getInfo')

        resetRouter()

        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, { root: true })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}